import styled from 'styled-components';
import Menu from '@mui/material/Menu';
import AppCSS from '../../utils/styled';
import { DEFAULT_MENU_WIDTH, MENU_MAX_HEIGHT } from '../../utils/styled/dimensions';
import { RADIUS_SIZES } from '../../utils/styled';

export const Components = {
  Menu: styled(Menu)`
    & .MuiPaper-root {
      ${AppCSS.radiuses.small};
      overflow-x: hidden;
      overflow-y: auto;
      max-width: ${DEFAULT_MENU_WIDTH}px;
      border: 1px solid ${AppCSS.colors.greys.light};
      ${AppCSS.boxShadows.menu};
      & .MuiList-root {
        display: flex;
        padding: 16px;
        flex-direction: column;
        gap: 16px;
      }
    }
  `,
  ItemsWrapper: styled.div<{ shouldHaveBorder?: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    max-height: ${MENU_MAX_HEIGHT}px;
    overflow-y: auto;
    overflow-x: hidden;
    ${({ shouldHaveBorder }) =>
      shouldHaveBorder &&
      `
        border: 1px solid ${AppCSS.colors.greys.light};
        border-bottom-left-radius: ${RADIUS_SIZES.small}px;
        border-top-left-radius: ${RADIUS_SIZES.small}px;
    `};
  `,
  PlaceholderWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 96px;
  `,
};
